export var RequestStatus;
(function(RequestStatus) {
    RequestStatus[RequestStatus["Processing"] = 0] = "Processing";
    RequestStatus[RequestStatus["Success"] = 1] = "Success";
    RequestStatus[RequestStatus["Failure"] = 2] = "Failure";
})(RequestStatus || (RequestStatus = {}));
